const calNumSuffix = (userData, office, designationObject ) =>{
    let numSuffixValue = "";
    const sameOfficeUsers = Object.values(userData)?.filter(x => (x.office.mainCharge ===  office) || (x.office.additionalCharge.includes(office)));
    const sameOfficeDesgnUsers = sameOfficeUsers?.filter(x => Object.values(x.designation).includes(designationObject[office]));
    const sortedSameOfficeDesgnUsers = sameOfficeDesgnUsers.sort((a,b) => (a.numSuffix[office] > b.numSuffix[office]) ? 1 : ((b.numSuffix[office] > a.numSuffix[office]) ? -1 : 0))
    if(!sortedSameOfficeDesgnUsers?.length){
        numSuffixValue = 1;
      }
    for(let i = 1; i < (sortedSameOfficeDesgnUsers?.length + 1); i++){
        if(sortedSameOfficeDesgnUsers[i-1]?.numSuffix[office] !== (sortedSameOfficeDesgnUsers[i]?.numSuffix[office]-1)){
            numSuffixValue = i+1;
          break;
        }           
    }
    return numSuffixValue;
}

export default calNumSuffix;
